const dateFns = require('date-fns');
function valueToString(value, name) {
    if (value > 0) {
        return `${value}${name}`;
    }
    return null;
}

export const PRECISION = {
    DAY: 1,
    HOUR: 2,
    MINUTE: 3,
    SECOND: 4,
};

const dateToArray = (precision, days, hours, minutes, seconds) => {
    const result = [];
    days = valueToString(days, 'd');
    if (precision >= PRECISION.DAY && days) {
        result.push(days);
    }
    hours = valueToString(hours, 'h');
    if (precision >= PRECISION.HOUR && hours) {
        result.push(hours);
    }
    minutes = valueToString(minutes, 'min');
    if (precision >= PRECISION.MINUTE && minutes) {
        result.push(minutes);
    }
    seconds = valueToString(seconds, 's');
    if (precision >= PRECISION.SECOND && seconds) {
        result.push(seconds);
    }
    return result;
};

export const timezoneDate = function(date, timezone) {
    const timezones = require('./timezones');
    let zone = timezones[timezone];
    let diff = date.getTimezoneOffset() / 60;
    // console.log('Timezone Difference', diff);

    // console.log('Before GMT0', date);
    if (diff < 0) {
        diff *= -1;
        date = dateFns.subHours(date, diff);
    } else if (diff > 0) {
        date = dateFns.addHours(date, diff);
    }

    // console.log('After GMT0', date);
    // console.log('--');
    // console.log('Zone:', timezone);
    // console.log('Zone GMT:', zone);
    // console.log('Before Zone:', date);
    if (zone > 0) {
        date = dateFns.addHours(date, zone);
    } else if (zone < 0) {
        zone *= -1;
        date = dateFns.subHours(date, zone);
    }

    // console.log('Afeter zone:', date);
    // console.log('');
    // console.log('-----------------');
    // console.log('');
    return date;
};
export const diffBetweenDates = function(date1, date2, precision = PRECISION.DAY) {
    // Set the unit values in milliseconds.
    const msecPerMinute = 1000 * 60;
    const msecPerHour = msecPerMinute * 60;
    const msecPerDay = msecPerHour * 24;

    // Get the difference in milliseconds.
    let interval = date1.getTime() - date2.getTime();

    // Calculate how many days the interval contains. Subtract that
    // many days from the interval to determine the remainder.
    const days = Math.floor(interval / msecPerDay);
    interval = interval - days * msecPerDay;

    // Calculate the hours, minutes, and seconds.
    const hours = Math.floor(interval / msecPerHour);
    interval = interval - hours * msecPerHour;

    const minutes = Math.floor(interval / msecPerMinute);
    interval = interval - minutes * msecPerMinute;

    const seconds = Math.floor(interval / 1000);

    if (days < 2) precision = PRECISION.HOUR;

    let result = dateToArray(precision, days, hours, minutes, seconds);
    while (result.length === 0 && precision <= PRECISION.SECOND) {
        result = dateToArray(++precision, days, hours, minutes, seconds);
    }
    if (result.length === 0) {
        result.push('0');
    }
    return result.join(' ');
};

export default diffBetweenDates;
